<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
        </div>
      </Card>

    </div>
    <p class="login-p">
      <img style="width:1vw;" src="https://img.alicdn.com/tfs/TB1..50QpXXXXX7XpXXXXXXXXXX-40-40.png" alt=""><a
        target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37010302001166">鲁公网安备
        37010302001166号</a>
    </p>
  </div>
</template>

<script>
  import LoginForm from "_c/login-form";
  import { mapActions, mapMutations } from "vuex";
  export default {
    data() {
      return {
        copy_right: ''
      }
    },
    components: {
      LoginForm
    },
    created() {
      //  this.$axios
      //   .get("/app/auth/getWebInfo")
      //   .then((res) => {
      //       if (res.code == 1) {
      //         this.copy_right=res.data.copy_right
      //       } else {
      //       this.$Message.error(res.msg);
      //       }
      //   });
    },
    methods: {
      ...mapActions(["getUserInfo", "getAuthList"]),
      ...mapMutations(["setBuisnessToken", "setUserInfo"]),
      handleSubmit({ userName, password }) {
        this.$axios
          .post("/app/auth/login", {
            name: userName,
            password: password
          })
          .then(res => {
            console.log("===")
            console.log(res)
            if (res.code == 1) {
              // console.log(process.env.VUE_APP_SITE_NAME)
              // process.env.VUE_APP_SITE_NAME=res.data.name
              this.setBuisnessToken(res.data.token);
              this.setUserInfo(res.data);
              this.getAuthList({ reload: true });
              // if(res.data.initFlag==1){
              //   this.$Message.warning('建议去修改下密码')
              //   this.$router.replace({
              //     name: 'BusinessManagement'
              //   });
              // }else{
              this.$router.replace({
                name: this.$config.homeName
              });
              // }
            } else {
              this.$Message.error(res.msg);
            }
          });
      }
    }
  };
</script>

<style lang="less">
  .login {
    width: 100%;
    height: 100%;
    background-image: url("../assets/images/login-bg.jpg");
    background-size: cover;
    background-position: center;
    position: relative;
    &-con {
      position: absolute;
      right: 160px;
      top: 50%;
      transform: translateY(-60%);
      width: 300px;
      &-header {
        font-size: 16px;
        font-weight: 300;
        text-align: center;
        padding: 30px 0;
      }
      .form-con {
        padding: 10px 0 0;
      }
      .login-tip {
        font-size: 10px;
        text-align: center;
        color: #c3c3c3;
      }
    }
    .login-p {
      position: fixed;
      bottom: 1vh;
      width: 100%;
      padding: 0 2vw;
      color: #c3c3c3;
      text-align: center;
    }
  }
</style>
